import Logo from '../assets/Untitled design (1).svg';

interface CivicBeatLogoProps {
  className?: string;
}

export default function CivicBeatLogo({ className = '' }: CivicBeatLogoProps) {
  return (
    <img
      src={Logo}
      alt="civicbeat logo"
      className={`h-5 md:h-6 w-auto object-contain hover:opacity-90 transition-opacity ${className}`}
    />
  );
}
